import { getBulkCloudMigrationInfo } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import { useCallback } from 'react';
import { useAsync } from 'react-async';
const transformDualLicenseData = function transformDualLicenseData(appKeys) {
  let dualLicenseData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return appKeys.reduce((obj, key) => {
    const dualLicenseDataForApp = dualLicenseData.find(app => app.addonKey === key);
    obj[key] = {
      isDualLicenseOptedIn: dualLicenseDataForApp === null || dualLicenseDataForApp === void 0 ? void 0 : dualLicenseDataForApp.isDualLicenseOptedIn
    };
    return obj;
  }, {});
};
export const useDualLicenseData = (mpacBaseUrl, partnerApps, enableDualLicenseToggleInPartnersTable) => {
  const promiseFn = useCallback(_ => {
    if (partnerApps !== null && partnerApps !== void 0 && partnerApps.count && enableDualLicenseToggleInPartnersTable) {
      const appKeys = partnerApps.apps.map(app => app.key);
      return getBulkCloudMigrationInfo(mpacBaseUrl, {
        addons: appKeys
      }).then(data => transformDualLicenseData(appKeys, data === null || data === void 0 ? void 0 : data.addons)).catch(_error => _error);
    }
  }, [partnerApps, enableDualLicenseToggleInPartnersTable]);
  const {
    data
  } = useAsync({
    promiseFn
  });
  if (data !== null && data !== void 0 && data.error) {
    log.error('useDualLicenseData', "Failed to retrieve Dual License Data", {
      error: data.error
    });
  }
  return {
    dualLicenseData: data,
    showDualLicenseError: !!(data !== null && data !== void 0 && data.error),
    showDualLicenseData: enableDualLicenseToggleInPartnersTable && data && !(data !== null && data !== void 0 && data.error)
  };
};